<div
  class="price-switch"
  [ngClass]="{
    'price-switch-sidenav': mobileSidenavMenu,
    'categories-menu-price-switch': !mobileSidenavMenu,
    'hidden-price-switch': (authState$ | async)?.type === PendingState
  }"
  [class.categories-menu-variant]="inCategoriesMenu"
>
  <div
    *ngIf="isTogglerActive"
    class="price-switch__container"
    test-target="price-switcher"
  >
    <button
      class="price-switch__btn"
      [ngClass]="{
        'price-switch__consumer': !mobileSidenavMenu,
        'price-switch__consumer-start': mobileSidenavMenu
      }"
      (click)="setPrice(b2c)"
      test-target="PRICE_TOGGLER.B_TO_C"
    >
      <p [ngClass]="{ bold: (priceType$ | async) === b2c }">
        {{ 'CORE.ALL_PAGES.PRICE_SWITCH.CONSUMER.LABEL' | translate }}
      </p>
      <p
        [ngClass]="{
          'price-switch__consumer--vat': !mobileSidenavMenu,
          'price-switch__consumer-start--vat': mobileSidenavMenu,
          bold: (priceType$ | async) === b2c
        }"
      >
        {{ 'CORE.ALL_PAGES.PRICE_SWITCH.CONSUMER.VAT_INFO.LABEL' | translate }}
      </p>
    </button>

    <input
      [checked]="(priceType$ | async) === b2b"
      (change)="onChange($event)"
      [id]="inputId"
      value="false"
      type="checkbox"
    />
    <label [for]="inputId" id="label-price-switch"></label>

    <button class="price-switch__business price-switch__btn" (click)="setPrice(b2b)" test-target="PRICE_TOGGLER.B_TO_B">
      <p [ngClass]="{ bold: (priceType$ | async) === b2b }">
        {{ 'CORE.ALL_PAGES.PRICE_SWITCH.BUSINESS.LABEL' | translate }}
      </p>
      <p class="price-switch__business--vat" [ngClass]="{ bold: (priceType$ | async) === b2b }">
        {{ 'CORE.ALL_PAGES.PRICE_SWITCH.BUSINESS.VAT_INFO.LABEL' | translate }}
      </p>
    </button>
  </div>

  <div class="price-switch__container" [class.disabled]="!isTogglerActive" *ngIf="!isTogglerActive">
    <p *ngIf="(priceType$ | async) === b2c" [ngClass]="{ bold: (priceType$ | async) === b2c }">
      {{ 'CORE.ALL_PAGES.PRICE_TYPE.LOGGEDIN_CONSUMER.LABEL' | translate }}
      {{ 'CORE.ALL_PAGES.PRICE_TYPE.VAT.LABEL' | translate: { type: b2c } }}
    </p>
    <p *ngIf="(priceType$ | async) === b2b" [ngClass]="{ bold: (priceType$ | async) === b2b }">
      {{ 'CORE.ALL_PAGES.PRICE_TYPE.LOGGEDIN_BUSINESS.LABEL' | translate }}
      {{ 'CORE.ALL_PAGES.PRICE_TYPE.VAT.LABEL' | translate: { type: b2b } }}
    </p>
  </div>
</div>
